import type { Team } from '@awork/features/team/models/team.model'
import type { AccessLevels } from '@awork/features/workspace/models/permissions.model'

interface IFilterTeamAccess {
  id: string
  teamId: string
  accessLevel: AccessLevels
  team?: Team
}

/**
 * The filter team access model
 */
export class FilterTeamAccess implements IFilterTeamAccess {
  id: string
  teamId: string
  accessLevel: AccessLevels
  team?: Team

  constructor(filterTeamAccess: Partial<IFilterTeamAccess>) {
    Object.assign(this, filterTeamAccess)
  }
}
